import React, {useState, useRef, useEffect, useContext} from 'react';
import {useHistory} from 'react-router-dom';
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from 'reactstrap';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import DeleteConfirmModal from './modals/DeleteConfirmModal';
import {usePopper} from 'react-popper';
import useClickOutside from 'Helpers/useClickOutside';
import {textTruncateByLength} from 'utils/other';
import ImageWithFallback from 'components/ImageWithFallback';
import Tooltip from 'components/Tooltip';
import {EntityContext} from 'contexts/EntityContext';

const EntityListItem = (props) => {
    let history = useHistory();
    let {pendingEntities} = useContext(EntityContext);
    const {
        entity, selectedCompanyData, entitiesLoading,
        activeEntity, setActiveEntity, refreshEntities, isActive,
        refreshSavedSearches,
    } = props;
    const containerRef = useRef();

    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        !isActive && isOpen && setIsOpen(false);
    }, [isActive]);

    const toggleOpen = () => setIsOpen((prevState) => !prevState);

    const toggleDeleteModal = () => {
        setDeleteModalOpen(!deleteModalOpen);
        isOpen && setIsOpen(false);
    };

    const handleEditSelect = () => {
        isOpen && setIsOpen(false);
        history.push(`/edit-entity/${entity.id}`);
    };

    const handleEntitySelect = () => !entitiesLoading && setActiveEntity(entity);

    return (
        <div
            id={'entity-' + entity.id}
            className={`entity-list-item ${isActive ? 'entity-list-item--active' : ''}`}
            style={selectedCompanyData && entity.id === selectedCompanyData.id ? {backgroundColor: 'white'} : {}}
        >
            <div className="entity-list-item__inner"
                 onClick={handleEntitySelect}>
                <div className="entity-list-item__logo">
                    {entity.logoUrl ?
                        // <div
                        //     className="icon-with-letter"
                        //     style={{
                        //         background: `url(${entity.logoUrl}) center center no-repeat`,
                        //         backgroundSize: 'contain',
                        //     }}
                        // />
                        // <LazyLoad height={40} width={40}  offset={100}>
                        //     <img className="icon-with-letter" src={entity.logoUrl} height={40}/>
                        // </LazyLoad>
                        <div style={{
                            borderRadius: '5px',
                            overflow: 'hidden',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}>
                            {/*<LazyLoadImage*/}
                            {/*    alt={`entity-filter-${entity.id}`}*/}
                            {/*    height={40}*/}
                            {/*    src={entity.logoUrl} // use normal <img> attributes as props*/}
                            {/*    width={40}*/}
                            {/*    style={{objectFit: 'contain'}}*/}
                            {/*    placeholder={<div style={{*/}
                            {/*        height: 40, width: 40,*/}
                            {/*        backgroundColor: '#e0e2e5'}}/>}*/}
                            {/*    // effect="opacity"*/}
                            {/*/>*/}
                            <ImageWithFallback
                                alt={`entity-filter-${entity.id}`}
                                height={40}
                                src={entity.logoUrl} // use normal <img> attributes as props
                                width={40}
                                style={{objectFit: 'contain'}}
                                itemTitle={entity.title}
                                fallbackColor={entity.color}
                                // placeholder={<div style={{
                                //     height: 40, width: 40,
                                //     backgroundColor: '#e0e2e5'}}/>}
                                // effect="opacity"
                            />
                        </div>

                        :
                        <div className="icon-with-letter" style={{backgroundColor: entity.color}}>
                            {entity.title && entity.title[0].toUpperCase()}
                        </div>
                    }
                </div>
                <div className="entity-list-item__info">
                    <div className="d-flex align-items-center">
                        <div
                            className="entity-list-item__title">{entity.title && textTruncateByLength(entity.title, 24)}</div>
                        {pendingEntities.indexOf(entity.id) > -1 &&
                        <div className="entity-list-item__status">
                            <Tooltip placement="bottom" wide tooltip={`Pending`}>
                                <div className="ml-2"
                                     style={{
                                         height: '10px',
                                         width: '10px',
                                         backgroundColor: '#f1c231',
                                         borderRadius: '50%',
                                     }}
                                />
                            </Tooltip>
                        </div>
                        }
                    </div>
                    <div>
                        {entity.domain ? textTruncateByLength(entity.domain, 22) : ''}
                    </div>
                </div>
            </div>
            {activeEntity && entity.id === activeEntity.id ?
                <div>
                    <Dropdown direction="down" isOpen={isOpen} toggle={toggleOpen}>
                        <DropdownToggle className="company-actions-dropdown-dots">
                            <Tooltip placement="bottom" wide tooltip={`Actions`} isVisible={isOpen ? false : undefined}>
                                <i style={{margin: '0'}} className="fas fa-ellipsis-v"/>
                            </Tooltip>
                        </DropdownToggle>
                        <DropdownMenu className="company-actions-dropdown-menu">
                            <DropdownItem onClick={handleEditSelect}>Edit</DropdownItem>
                            <DropdownItem onClick={toggleDeleteModal}>Delete</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>
                :
                <div style={{width: '35px', height: '62px'}} onClick={handleEntitySelect}/>
            }
            {deleteModalOpen && (
                <DeleteConfirmModal
                    isOpen={deleteModalOpen}
                    toggle={toggleDeleteModal}
                    activeEntity={activeEntity}
                    refreshEntities={refreshEntities}
                />
            )}
        </div>
    );
};

export default EntityListItem;
